import React from "react";
import ReactDOM from "react-dom/client";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./components/redux/store/store"; // Import persistor
import { PersistGate } from "redux-persist/integration/react";
import { PermissionProvider } from "./context/PermissionContext";
import { modules } from "./utils/App Module/ModulesHelper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PermissionProvider modules={modules}>
          <App />
        </PermissionProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Measure performance (optional)
reportWebVitals();

